export const messages = {
  label: {
    startDate: {
      id: 'activityLog.Label.StartDate',
      defaultMessage: 'Start Date:',
    },
    endDate: {
      id: 'activityLog.Label.EndDate',
      defaultMessage: 'End Date:',
    },
    title: {
      id: 'activityLog.Label.Title',
      defaultMessage: 'Activity Log',
    },
    instructions1: {
      id: 'activityLog.Label.Instructions1',
      defaultMessage: 'The Activity Log allows you to review a history of ' +
        'portal activity within a specific time period. ' +
        'For example, it will include actions such as viewing a blood test or completing a questionnaire.',
    },
    instructions2: {
      id: 'activityLog.Label.Instructions2',
      defaultMessage: 'The log is provided as a download in CSV file format, ' +
        'which can be opened by a spreadsheet application.',
    },
  },
  button: {
    viewActivityLog: {
      id: 'activityLog.Button.ViewActivityLog',
      defaultMessage: 'View Activity Log',
    },
  },
};
